'use strict';

require('../common/main');

// kalendář programů
import './schedule/main'